<template>
    <div class="min-profile-container">
      <span v-text="'☰'" @click="changeHomeMenuVisibility" style="margin-bottom: 5px;"></span>
        <!-- <div class="img">
            <img :src="userImgMock"/>
        </div> -->
         <span v-if="getUser?.consumerName" class="name">
          <div>Olá, {{ fixName(getUser.consumerName) }}</div>
          <div v-if="getUser?.contractName" class="plan-name" v-text="getUser.contractName"></div>
          <div v-else class="plan-name">NÃO ASSOCIADO</div>
         </span>
        <span v-else></span>

        <div class="header">
          <img class="logo" :src="getAppDefinitions?.appLogo">
        </div>
    </div>
  </template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'MinProfile',
  components: {},
  data () {
    return {
      userImgMock: require('@/assets/img/profile-default.png')
    }
  },
  computed: {
    ...mapGetters(['getUser', 'getAppDefinitions'])
  },
  methods: {
    ...mapActions(['changeHomeMenuVisibility']),
    fixName (name) {
      if (name) {
        return name.split(' ')[0]
      } else {
        return ''
      }
    }
  }
}
</script>

  <style scoped lang="less">
  .min-profile-container {
    position: fixed;
    top:0;
    left: 0;
    width: -webkit-fill-available;
    height: 60px;
    padding: 20px 20px 10px 20px;
    background: white;
    display: grid;
    grid-template-columns: 30px 1fr auto; // with image: grid-template-columns: 30px 60px auto 130px;
    z-index: 2;

    .img {
        position: relative;
        display: inline-flex;
        height: 48px;
        width: 48px;
        border-radius: 100%;
        flex-direction: row;
        flex-wrap: wrap;
        align-content: center;
        justify-content: center;
        align-items: center;
        color: white;
        margin-right: 20px;
        img, svg{
            height: 48px;
            object-fit: contain;
        }
    }
    span {
        display: flex;
        margin: auto 0;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        &:first-of-type {
          color: var(--primaryColor);
          font-size: 24px;
        }
    }

    .name {
      font-size: 16px;
      line-height: 20px;
      color: var(--primaryColor);
      margin-bottom: 5px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .plan-name {
        font-size: 12px;
        color: var(--secondaryColor);
      }
    }

    .logo {
      height: 50px;
      margin-top: 5px;
      object-fit: contain;
    }
  }
  </style>
